var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dl",
    {
      staticClass: "icon-details-aliases display-inline-flex flex-items-center",
      staticStyle: {
        "--margin-bottom": "0",
        "--padding-left": "0",
        gap: "var(--spacing-md)",
      },
    },
    [
      _c(
        "dt",
        {
          staticClass: "muted sr-only",
          staticStyle: {
            "--margin-bottom": "0",
            "font-weight": "var(--font-weight-normal)",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.aliasLabel) + ":\n  ")]
      ),
      _vm._v(" "),
      _vm._l(_vm.aliases, function (alias) {
        return _c(
          "dd",
          { key: alias, staticStyle: { "--margin-bottom": "0" } },
          [
            _c(
              "span",
              {
                staticClass: "tag teal rounded text-select-all",
                staticStyle: {
                  "--tag-letter-spacing": "0",
                  "--tag-text-transform": "none",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "text-lowercase",
                    staticStyle: { "letter-spacing": "0.0625em" },
                  },
                  [_vm._v(_vm._s(alias))]
                ),
              ]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }